// TODO: Permitir en un futuro pasarle mode ( hide | disable )
export default {
    inserted(el, binding, vnode) {
        const permisos = binding.value

        const store = vnode.context.$store

        if (!permisos) return

        const hasPermission = store.getters['auth/hasPermiso'](permisos)
        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    }
}
